import React, { useEffect, useRef } from 'react';
import { startHoloScene } from './holoRenderer';
import styles from './Hero.module.css';

const HoloScene = () => {
  const canvasRef = useRef(null);
  const stateRef = useRef(null);
  const nameRef = useRef(null);
  const barRef = useRef(null);

  useEffect(
    () =>
      startHoloScene(canvasRef.current, {
        state: stateRef.current,
        name: nameRef.current,
        bar: barRef.current,
      }),
    []
  );

  return (
    <div className={styles.holo}>
      <canvas
        ref={canvasRef}
        role="img"
        aria-label="Animated 3D buildings rebuilding from ruins while rotating through 360 degrees"
      />
      <div className={styles.hud} aria-hidden="true">
        <span className={styles.hudDot} />
        <span ref={stateRef}>Rebuilding</span>
        <b ref={nameRef} />
        <span className={styles.hudBar}>
          <i ref={barRef} />
        </span>
      </div>
    </div>
  );
};

export default HoloScene;
